import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FazerPedidoService} from '@services/fazer-pedido.service';
import {take} from 'rxjs/operators';
import {Router, ActivatedRoute} from '@angular/router';
import {HttpResponse} from '@angular/common/http';
import {FilenameParser} from '@utils/FilenameParser';
import {FileDownloadService} from '@services/file-download.service';
import {PedidoAvulsoFormInterface} from '@interfaces/pedido-avulso';
import {SummaryRequest} from '@interfaces/summary-request';
import {TagManagerService} from '@services/tag-manager.service';
import {GoogleTagManagerEventEnum} from 'src/app/enums/GoogleTagManagerEvent.enum';
import {GoogleTagManagerModel} from 'src/app/models/google-tag-manager.model';
import {PedidoFormBase} from '../shared/pedido-form/pedido-form.base';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { AlertAlterarEnderecoComponent } from '../../components/alert-alterar-endereco/alert-alterar-endereco.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { AlertConfirmarPedidoComponent } from '../../components/alert-confirmar-pedido/alert-confirmar-pedido.component';
import { AlertErroCustomizadoComponent } from '../../components/alert-erro-customizado/alert-erro-customizado.component';
import { DetalhesErrosCnpjComponent } from '../../components/detalhes-erros-cnpj/detalhes-erros-cnpj.component';
import { AlertIgnorarErrosComponent } from '../../components/alert-ignorar-erros/alert-ignorar-erros.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { TagManagerDirective } from '../../directives/tag-manager.directive';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { PedidoFormFieldsComponent } from '../shared/pedido-form/pedido-form-fields.component';
import { NgClass, CurrencyPipe } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';
import { CnpjPipe } from '../../pipes/cnpj.pipe';

@Component({
    selector: 'app-fazer-pedido',
    templateUrl: './fazer-pedido.component.html',
    styleUrls: ['./fazer-pedido.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, AlertAlterarEnderecoComponent, LoadingGenericoComponent, AlertConfirmarPedidoComponent, AlertErroCustomizadoComponent, DetalhesErrosCnpjComponent, AlertIgnorarErrosComponent, BreadcrumbComponent, TagManagerDirective, PopoverDirective, PedidoFormFieldsComponent, NgClass, FooterComponent, CurrencyPipe, CamelCasePipe, CnpjPipe]
})
export class FazerPedidoComponent extends PedidoFormBase implements OnInit {
  private readonly sectionApp = 'fazer-pedido-integral';
  private readonly screenName = 'fazer-pedido-integral:home';
  private readonly screenType = 'pagina';

  public loadingGenerico: any = false;
  public idEmpresa: any;
  private pedidoBody = {} as PedidoAvulsoFormInterface;
  public enderecosFaturamento: any = null;
  public enderecoSelecionado: any;
  public ignorarInconsistencias = false;
  public existemErros: any = false;
  public mensagemBotaoErroApi: any = 'FECHAR';
  public alertLoading = false;
  public showAlertAlterarEndereco = false;
  public showAlertErro = false;
  public mensagemErroApi: string;
  public baixouRelatorio = false;
  public checkCancelar = false;
  public recargaCerta = false;
  public idImportacao;
  public idPedidoAtivo: any;
  public tituloErroApi: string;
  public idEmpresaEndFaturamento: any;
  public dadosUltimoPedido: any;
  public erroPedido = false;
  public alertErroPedidoCnpj = false;
  public idEmpresaDetalheErro: any;
  public detalhesErroCnpj: any;
  public alertIgnorarErroPedido: boolean;
  public showBaixarRelatorio: boolean;
  public erroCnpj: boolean;
  public clickDownloadRelatorioErros: boolean;
  public orderEmpList: any;
  public bodyRequest: SummaryRequest[] = [];
  public bodyErrorsCsvRequest: SummaryRequest[] = [];

  constructor(protected readonly fazerPedidoService: FazerPedidoService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute,
              private readonly tagManagerService: TagManagerService,
  ) {
    super(fazerPedidoService);
  }

  ngOnInit(): void {
    this.init();
    this.getDadosUltimoPedido();
    this.tagManagerService.pushTag(this.buildTagModel(GoogleTagManagerEventEnum.screenView, null, null));
  }

  private init() {
    this.loadingGenerico = true;
    this.ordemEnvelopes = 'N';
    this.bodyRequest = [];
    this.bodyErrorsCsvRequest = [];

    if (localStorage.listaEmpresaPedido != '') {
      this.orderEmpList = JSON.parse(localStorage.listaEmpresaPedido);
      this.orderEmpList.forEach(element => {
        const objeto = {
          idEmpresa: element.companyList[0].companyDetail.companyId,
          idPedidoAtivo: element.companyList[0].companyDetail.activeOrderId
        };
        this.bodyRequest.push(objeto);
      });
    }

    const idEmpresas = this.orderEmpList.map(obj => {
      return {
        idEmpresa: obj.companyList[0].companyDetail.companyId
      };
    });
    this.activatedRoute.queryParams.subscribe(async ({recargaCerta}) => {
      localStorage.setItem('idEmpresasPedidoIntegral', idEmpresas);
      this.recargaCerta = recargaCerta ?? false;

      if (!idEmpresas) {
        this.idEmpresa = localStorage.getItem('idEmpresaLogada');
      } else if (Array.isArray(idEmpresas)) {
        this.idEmpresa = idEmpresas[0].idEmpresa;
      } else {
        this.idEmpresa = localStorage.getItem('idEmpresasPedidoIntegral');
      }

      this.checkCancelar = !!idEmpresas;
      this.getNovosValoresResumoPedido();
    });
    this.fazerPedidoService.getAllContatos(this.idEmpresa)
      .pipe(take(1)).subscribe({
        next: (resposta: any) => { this.contatos = resposta.response; },
        error: (error: any) => { console.error(error); }
      });

    this.loadingGenerico = false;
  }

  checkStatusCnpj(idEmpresa, idPedidoAtivo) {
    this.loadingGenerico = true;
    this.fazerPedidoService.checkErroCnpj(idEmpresa, idPedidoAtivo)
      .pipe(take(1)).subscribe({
        next: (response: any) => {
          this.loadingGenerico = false;
          this.alertErroPedidoCnpj = true;
          this.detalhesErroCnpj = response.response;
        },
        error: (error: any) => {
          console.error(error);
          this.loadingGenerico = false;
        }
      });
    this.idEmpresaDetalheErro = idEmpresa;
  }

  getDadosUltimoPedido() {
    this.fazerPedidoService.recuperaDadosUltimoPedido(this.idEmpresa)
      .pipe(take(1)).subscribe({
        next: (response: any) => {
          this.dadosUltimoPedido = response.response;
          if (this.dadosUltimoPedido.ordemEnvelopes != null && this.dadosUltimoPedido.ordemEnvelopes !== '') {
            this.ordemEnvelopes = this.dadosUltimoPedido.ordemEnvelopes;
          }
          this.emailConfirmacao = this.dadosUltimoPedido.emailContato;
          this.emailNfe1 = this.dadosUltimoPedido.emailNf1;
          this.emailNfe2 = this.dadosUltimoPedido.emailNf2;
          if (this.dadosUltimoPedido.idContatoResponsavel != null) {
            this.contatoSelecionado = this.dadosUltimoPedido.idContatoResponsavel;
          }
        },
        error: (error: any) => { console.error(error); }
      });
  }

  getValoresPedido(idPedidoAtivo: any) {
    this.fazerPedidoService.recuperaValoresCalculador(this.idEmpresa, idPedidoAtivo)
      .pipe(take(1)).subscribe({
        next: (response: any) => {
          this.enderecosFaturamento = response;
          this.getErroInconsistencia(this.enderecosFaturamento.response);
        },
        error: (error: any) => {
          this.showAlertErro = true;
          this.tituloErroApi = 'Ocorreu erro ao recuperar dados do pedido!';
          this.mensagemErroApi = error.error.mensagem;
          this.alertLoading = false;
        }
      });
  }

  getErroInconsistencia(enderecos: any) {
    enderecos.forEach(endereco => {
      if (endereco?.errosValidacao) {
        this.showBaixarRelatorio = true;
        this.erroCnpj = true;
        this.bodyErrorsCsvRequest.push({
          idEmpresa: endereco.empresa.id,
          idPedidoAtivo: endereco.idPedidoAtivo
        });
      }
    });
  }

  cancelarPedido() {
    this.fazerPedidoService.cancelaPedidoPost(this.bodyRequest).pipe(take(1)).subscribe({
      next: () => {
        if (this.checkCancelar) {
          this.router.navigate(['/fazer-pedido-integral'], {queryParams: {recargaCerta: this.recargaCerta}});
        } else {
          this.router.navigate(['/importador-dados']);
        }
      },
      error: (error: any) => { console.error(error); }
    });
  }

  abrirEdicaoEnderecoFaturamento(enderecosFaturamento: any) {
    this.idEmpresaEndFaturamento = enderecosFaturamento.empresa.id;
    this.enderecoSelecionado = enderecosFaturamento;
    this.idPedidoAtivo = enderecosFaturamento.idPedidoAtivo;
    this.showAlertAlterarEndereco = true;
  }

  onSubmit(evento: any) {
    if (evento) {
      this.createPedidoBody();
      if (this.isErrorFields === false) {
        this.alertLoading = true;
        this.fazerPedidoService.createPedidoIntegralPost(this.pedidoBody, this.idEmpresa, this.idPedidoAtivo)
          .pipe(take(1))
          .subscribe({
            next: () => {
              this.alertLoading = false;
              localStorage.removeItem('idEmpresasPedidoIntegral');
              localStorage.removeItem('listaEmpresaPedido');
              this.router.navigate(['resumo-pedido']);
            },
            error: () => {
              this.alertLoading = false;
              this.showAlertErro = true;
              this.tituloErroApi = 'Ocorreu ao realizar pedido!';
              this.mensagemErroApi = 'Favor tentar novamente.';
            }
          });
      } else {
        this.pedidoBody = {} as PedidoAvulsoFormInterface;
      }
    }
  }

  private createPedidoBody() {
    const pedidoAvulsoForm = {} as PedidoAvulsoFormInterface;
    this.isErrorFields = false;

    this.validarContato(pedidoAvulsoForm);
    this.validarDataPagamento(pedidoAvulsoForm);
    this.validarDataInicial(pedidoAvulsoForm);
    this.validarDataFinal(pedidoAvulsoForm);
    this.validarEnvelopes(pedidoAvulsoForm);
    this.validarEmails(pedidoAvulsoForm);

    if (this.bodyRequest) {
      pedidoAvulsoForm.dadosEmpresasPedidos = this.bodyRequest;
    }
    pedidoAvulsoForm.idPedidoAtivo = this.idPedidoAtivo;
    pedidoAvulsoForm.ddd = '';
    pedidoAvulsoForm.msgEnv = '';
    pedidoAvulsoForm.numCel = '';
    this.pedidoBody = pedidoAvulsoForm;
  }

  eventoAlertAlterarEndereco(evento: any) {
    if (evento) { this.getNovosValoresResumoPedido(); }
    this.showAlertAlterarEndereco = false;
  }

  eventoAlertDetalheErrosCnpj(evento: any) {
    this.alertErroPedidoCnpj = false;
  }

  eventoAlertErro() {
    this.showAlertErro = false;
    this.cancelarPedido();
  }

  downloadRelatorioErros() {
    this.fazerPedidoService.downloadErrosPedidoPost(this.idEmpresa, this.bodyErrorsCsvRequest).subscribe({
      next: ({body, headers}: HttpResponse<any>) => {
        const filename = FilenameParser.fromContentDispositionHeader(
          headers.get('content-disposition'), 'Arquivo.csv',
        );
        this.clickDownloadRelatorioErros = true;
        this.erroCnpj = false;
        FileDownloadService.download([body], filename);
      },
      error: (erro: any) => {
        console.error(erro);
        this.showAlertErro = true;
        this.mensagemBotaoErroApi = 'FECHAR';
        this.mensagemErroApi = erro.message;
      }
    });
  }

  fecharAlertIgnorarErros() {
    this.alertIgnorarErroPedido = false;
  }

  getNovosValoresResumoPedido() {
    this.alertLoading = true;
    this.fazerPedidoService.recuperaValoresResumidosPorIdEmpresaPedidoAtivo(this.bodyRequest)
      .pipe(take(1)).subscribe({
        next: (response: any) => {
          this.enderecosFaturamento = response;
          this.checkMeioPagamento();
          this.getErroInconsistencia(this.enderecosFaturamento.response);
          this.alertLoading = false;
        },
        error: (error: any) => {
          this.showAlertErro = true;
          this.tituloErroApi = 'Ocorreu erro ao recuperar dados do pedido!';
          this.mensagemErroApi = error.error.mensagem;
          this.alertLoading = false;
        }
      });
  }

  checkMeioPagamento() {
    this.enderecosFaturamento.response.forEach(empresa => {
      if (empresa.empresa.meioPagamento === 'Pré-Pago') {
        this.prePago = true;
      }
    });
  }

  addTagManagerInteraction(elementType: string, elementContent: string): GoogleTagManagerModel {
    return this.buildTagModel(GoogleTagManagerEventEnum.interaction, elementType, elementContent);
  }

  private buildTagModel(event: GoogleTagManagerEventEnum, elementType: string, elementContent: string): GoogleTagManagerModel {
    const model = new GoogleTagManagerModel();
    model.event = event;
    model.element_type = elementType;
    model.element_content = `none:${elementContent}:none`;
    model.section_app = this.sectionApp;
    model.screen_name = this.screenName;
    model.screen_type = this.screenType;
    return model;
  }
}
